import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SetCardContainer,
  SetName,
  SetDescription,
  SetTags,
  SetDates,
  DatePill,
  TagsList,
  TagItem
} from './SetCard.styles.js';

import CardCountPill from '../../../../components/card-count-pill/CardCountPill.js';

export default function SetCard({ set, isMultiSelectMode, isSelected, onSelect }) {
  const navigate = useNavigate();

  const handleSetClick = () => {
    if (isMultiSelectMode) {
      onSelect();
    } else {
      navigate(`/sets/${set.id}`);
    }
  };

  // Calculate how many tags can fit in 2 rows
  const calculateVisibleTags = (tags) => {
    if (!tags || tags.length === 0) return { visibleTags: [], remainingCount: 0 };
    
    // Estimate characters per row based on container width (approximately 300px)
    // Average tag width is roughly 8-12 characters + padding
    const estimatedCharsPerRow = 48; // Conservative estimate
    const maxChars = estimatedCharsPerRow * 2; // 2 rows
    
    let charCount = 0;
    let visibleCount = 0;
    
    for (let i = 0; i < tags.length; i++) {
      const tagLength = tags[i].length + 4; // +4 for padding and gap
      if (charCount + tagLength <= maxChars) {
        charCount += tagLength;
        visibleCount++;
      } else {
        break;
      }
    }
    
    return {
      visibleTags: tags.slice(0, visibleCount),
      remainingCount: Math.max(0, tags.length - visibleCount)
    };
  };

  const { visibleTags, remainingCount } = calculateVisibleTags(set.tags);

  return (
    <SetCardContainer
      $isClickable={set.itemCount > 0} 
      $isMultiSelectMode={isMultiSelectMode}
      $isSelected={isSelected}
      onClick={handleSetClick}
    >
      {isMultiSelectMode && (
        <div style={{ 
          position: "absolute", 
          top: "12px", 
          right: "12px", 
          zIndex: 10 
        }}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
              accentColor: "#4CAF50"
            }}
          />
        </div>
      )}
      <div>
        <SetName>{set.title}</SetName>

        {set.description && (
          <SetDescription>{set.description}</SetDescription>
        )}
      

      {set.tags && set.tags.length > 0 && (
        <SetTags>
          <TagsList>
            {visibleTags.map((tag, index) => (
              <TagItem key={index}>{tag}</TagItem>
            ))}
            {remainingCount > 0 && (
              <TagItem $isMoreIndicator>
                +{remainingCount} More
              </TagItem>
            )}
          </TagsList>
        </SetTags>
      )}
      </div>

      <SetDates>
        <DatePill>
          <span>Created {new Date(set.createdAt).toLocaleString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit'
          })}</span>
        </DatePill>
        <CardCountPill value={set.itemCount || 0} />
        <DatePill>
          <span>Updated {new Date(set.updatedAt || set.createdAt).toLocaleString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: '2-digit'
          })}</span>
        </DatePill>
      </SetDates>
    </SetCardContainer>
  );
}
